import { ApplicationEnvironment } from './environment.model';

export const environment: ApplicationEnvironment = {
  production: false,
  name: 'environment development cloud',
  appName: 'Name',
  apiScopes: ['api://890efbd1-fbbe-4d97-83ee-20c652cea4f2/access_as_user'],
  apiUrl: 'https://engtoolapi.engineeringhub.dev.gea.com',
  engtoolapi: 'https://engtoolapi.engineeringhub.dev.gea.com',
  iotestapi: 'https://iotestapi.engineeringhub.dev.gea.com',
  swaggerSpecUrl: 'https://<dev-openapi-host>/<openapi-spec-path>',
  msalConfig: {
    auth: {
      clientId: '890efbd1-fbbe-4d97-83ee-20c652cea4f2',
      authority: 'https://login.microsoftonline.com/0e17f90f-88a3-4f93-a5d7-cc847cff307e', // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
      redirectUri: 'https://iotestapp.engineeringhub.dev.gea.com',
      postLogoutRedirectUri: 'https://iotestapp.engineeringhub.dev.gea.com'
    }
  }
};
